export default __webpack_public_path__ + "static/media/material.8c7f838a.svg";